import mixpanel from 'mixpanel-browser'

const DEV_TOKEN = 'a5c5ff9b7021e3bb1026bb54e2a82b17'
const PROD_TOKEN = '44385eb5127adbf0610f406a6595029c'

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 */
let init = (environment) => {
  switch (environment) {
    case 'prod':
      mixpanel.init(PROD_TOKEN)
      break
    default:
      mixpanel.init(DEV_TOKEN)
  }
}

/**
 * Track an event. This is the most important and frequently used
 * Mixpanel function.
 * @param event
 * @param properties
 */
let track = (event, properties) => {
  mixpanel.track(event, properties)
}

/**
 * Opt the user out of data tracking and cookies/localstorage for
 * this Mixpanel instance
 */
let optOut = () => {
  mixpanel.opt_out_tracking()
}

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage
 * for this Mixpanel instance
 */
let hasOptedOut = () => {
  return mixpanel.has_opted_out_tracking()
}

/**
 * Opt the user in to data tracking and cookies/localstorage for
 * this Mixpanel instance
 */
let optIn = () => {
  mixpanel.opt_in_tracking()
}

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage
 * for this Mixpanel instance
 */
let hasOptedIn = () => {
  return mixpanel.has_opted_in_tracking()
}

/**
 *  Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an array
 * of event names, those events will be disabled, but other events
 * will continue to be tracked.
 * @param events
 */
let disable = (events) => {
  mixpanel.disable(events)
}

/**
 * Identify a user with a unique ID instead of a Mixpanel randomly
 * generated distinct_id
 * @param id
 */
let identify = (id) => {
  mixpanel.identify(id)
}

/**
 * Set properties on a user record.
 * @param properties
 */
let setProperties = (properties) => {
  mixpanel.people.set(properties)
}

/**
 * Clears super properties and generates a new random distinct_id
 * for this instance. Useful for clearing data when a user logs out.
 */
let reset = () => {
  mixpanel.reset()
}

/**
 * Returns the current distinct id of the user.
 */
let getDistinctId = () => {
  return mixpanel.get_distinct_id()
}

export default {
  init,
  track,
  optOut,
  hasOptedOut,
  optIn,
  hasOptedIn,
  disable,
  identify,
  setProperties,
  reset,
  getDistinctId
}
